import { useSelector } from 'react-redux'

import {
  selectCurrentSeniorYear,
  selectHighSchoolEnabled,
  selectIdentifier,
  selectMiddleSchoolEnabled,
  selectName,
  selectOrg,
  selectSISConfig,
} from '.'

export const useOrganizationId = () => useSelector(selectIdentifier)
export const useOrganizationName = () => useSelector(selectName)
export const useHighSchoolSISConfig = () => useSelector(selectSISConfig)
export const useOrganization = () => useSelector(selectOrg)
export const useOrganizationHighSchoolProductEnabled = () => useSelector(selectHighSchoolEnabled)
export const useOrganizationMiddleSchoolProductEnabled = () => useSelector(selectMiddleSchoolEnabled)
export const useOrganizationCurrentSeniorYear = () => useSelector(selectCurrentSeniorYear)
